<show-message [type]="messageType.INFO" class="reversal-container">
    <div info class="reversal-notification">
        <strong>
            {{ 'PARTY.CASHIER.web.deposit.currency.message' | translate: { defaultCurr: defaultCurrency() | vnCurrencySymbol } }}
        </strong>
        <a class="d-flex flex-row justify-content-end" (click)="gotoAllOptions()" id="gotoAllOptions">
            {{ 'PARTY.CASHIER.web.deposit.currency.link' | translate }}
        </a>
    </div>
</show-message>
